// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"28ad867c","154":"b2fa4335","214":"0c8ff188","286":"36ab15df","326":"3ada1844","381":"7d4de0d3","435":"5d00bf9c","501":"71e99645","770":"93a5aaa5","908":"306f368a"}[chunkId] + ".chunk.js";
};